import React from "react";
interface PaymentTabProps {
  setSelectedMethod: (value: string) => void;
  paymentMethodList: any;
  selectedMethod: string;
}
const PaymentMethodTab = ({
  setSelectedMethod,
  paymentMethodList,
  selectedMethod,
}: PaymentTabProps) => {
  return (
    <>
      {paymentMethodList?.map((data: any, index: number) => {
        return (
          <div
            key={index}
            className={`flex-1 px-[15px] py-[10px] flex items-center gap-2  border-[1px] rounded-md cursor-pointer w-full text-txtPrimary hover:!bg-bgSecondary hover:!border-strokeActive ${
              selectedMethod === data.name
                ? "bg-btnBackGround border-btnOutlineStroke"
                : "bg-white border-strokePrimary "
            }`}
            onClick={() => setSelectedMethod(data.name)}
          >
            {data.icon ? (
              <div>
                {React.cloneElement(data.icon, {
                  strokeColor: `${
                    selectedMethod === data.name
                      ? "var(--color-btn-primary-active)"
                      : "var(--color-icon-bright)"
                  }`,
                })}
              </div>
            ) : null}
            <p className="text-sm font-normal capitalize">{data.name}</p>
          </div>
        );
      })}
    </>
  );
};

export default PaymentMethodTab;
